/**
 * "Why we work this way" — homepage note. An unattributed team statement:
 * no name, no photo, no signature, no first person.
 */
export function About() {
  return (
    <section data-testid="about-section" className="bg-wafa-cream/50">
      <div className="mx-auto grid max-w-7xl gap-14 px-4 py-20 lg:grid-cols-12 lg:gap-16 lg:px-6 lg:py-28">
        <div className="lg:col-span-7">
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">About</div>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
            An Oman-based technology company, and the technology partner to Altalib Group.
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
            <p>
              We are a services company and a product company. The delivery platform, the warehouse
              system, the showroom platform and Meyar are all ours — designed by our team, built by
              our engineers, and running in real businesses today.
            </p>
            <p>
              That mix matters. It means the code you get is battle-tested against the same
              problems your business is solving. And it means the people talking to you have
              actually shipped something.
            </p>
          </div>

          <div data-testid="why-we-work-this-way" className="mt-10 rounded-xl border border-wafa-deep/10 bg-white p-6 lg:p-8">
            <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">
              Why we work this way
            </div>
            <p className="mt-4 text-base leading-relaxed text-wafa-ink/90 lg:text-lg">
              Most software fails for reasons that have nothing to do with code. The scope was
              vague, nobody saw anything for months, and the vendor vanished after go-live. We
              built this company to work the opposite way — you see working software every two
              weeks, you know what everything costs, and we are still here when you need a change
              in year three.
            </p>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-lg border border-wafa-deep/10 bg-white p-5">
              <div className="font-heading text-3xl font-semibold text-wafa-deep">Oman</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-wafa-ink/60">Head office</div>
            </div>
            <div className="rounded-lg border border-wafa-deep/10 bg-white p-5">
              <div className="font-heading text-3xl font-semibold text-wafa-deep">4</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-wafa-ink/60">Countries · Oman, India, USA, Philippines</div>
            </div>
            <div className="rounded-lg border border-wafa-deep/10 bg-white p-5">
              <div className="font-heading text-3xl font-semibold text-wafa-deep">Own products</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-wafa-ink/60">Built, owned and operated — with more in build</div>
            </div>
            <div className="rounded-lg border border-wafa-deep/10 bg-white p-5">
              <div className="font-heading text-3xl font-semibold text-wafa-deep">SLA</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-wafa-ink/60">Written · every engagement</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
